import { FC } from 'react'
import { PastCardCheckbox } from 'components/features/future/FutureLayerPast/PastCardCheckbox/PastCardCheckbox'

type UpdateMaterialStatusProps = {
}
export const UpdateMaterialStatus: FC<UpdateMaterialStatusProps> = () => {
  return (
    <>
      <PastCardCheckbox
        name='set_marital_status'
        label='Update marital status in your assumptions'
      />
    </>
  )
}
